import React, { useEffect, useMemo, useRef, useState } from 'react';
import BackgroundCanvas from "./BackgroundCanvas.js";
import Page1 from "./Page1.js";
import Page2 from "./Page2.js";
import Page1Mobile from "./Page1Mobile.js";
import { Vector2 } from './geometry.js';
import { getDeviceType } from './Global.js';
import Page2Mobile from './Page2Mobile.js';

function App() {
    /** @type {React.MutableRefObject<BackgroundCanvas | null>} */
    const backgroundCanvasRef = useRef(null);
    const [aspectRatio, setAspectRatio] = useState(window.innerWidth / window.innerHeight);
    const [sizeXscrollbar, setsizeXscrollbar] = useState(new Vector2(document.body.clientWidth, document.body.clientHeight));
    const prevSizeX = useRef(window.innerWidth);
    const prevSizeY = useRef(window.innerHeight);

    const canvasHint = useRef(null);
    const [canvasResolution, setCanvasResolution] = useState(
        new Vector2(Vector2.unit("50vw"), Vector2.unit("88vh"))
    );

    const resizeTimeout = useRef(null);
    useEffect(() => {
        const handleResize = () => {
            if (resizeTimeout.current) {
                clearTimeout(resizeTimeout.current);
            }

            resizeTimeout.current = setTimeout(() => {
                if (getDeviceType() !== "PC"/* && prevSizeX.current === window.innerWidth*/) {
                    return;
                }
    
                console.log("[App] HandleResize of the page is called");
                prevSizeX.current = window.innerWidth;
                prevSizeY.current = window.innerHeight;
    
                setsizeXscrollbar(new Vector2(document.body.clientWidth, document.body.clientHeight));
                setAspectRatio(document.body.clientWidth / document.body.clientHeight);
                setCanvasResolution(new Vector2(Vector2.unit("50vw"), Vector2.unit("88vh")));
            }, 500);
        };
        // handleResize();

        const handleScroll = () => {
            const canvas = document.querySelector('.background');
            const canvasHint = document.querySelector('.canvas-hint');
            const page2 = document.querySelector('.page2'); // Ensure Page2 has this ID
    
            if (!canvas || !page2 || !canvasHint) return;
    
            const canvasHeight = canvas.offsetHeight;
            const canvasHintHeight = canvasHint.offsetHeight;

            const canvasBottomIfFixed = window.scrollY + canvasHeight; // Simulating its bottom if fixed
            const page2Top = page2.offsetTop;

            if (canvasBottomIfFixed >= page2Top) {
                // Stop at page2
                canvas.style.position = 'absolute';
                canvas.style.top = `${page2Top - canvasHeight}px`;

                canvasHint.style.position = 'absolute';
                canvasHint.style.top = `${page2Top - canvasHintHeight}px`;
                canvasHint.style.bottom = 'unset';
            } else {
                // Keep it fixed at the top
                canvas.style.position = 'fixed';
                canvas.style.top = '0';

                canvasHint.style.position = 'fixed';
                canvasHint.style.top = 'unset';
                canvasHint.style.bottom = '0';
            }
        };
        handleScroll();

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        // window.addEventListener('scroll', headerHandle);
    
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        //   window.removeEventListener('scroll', headerHandle);
        };
    }, []);


    const resolution = useMemo(() => {
        console.log(Vector2.unit("100vw"));
        return Vector2.unit("100vw") < 1200 
            ? sizeXscrollbar 
            : new Vector2(Vector2.unit("100vw"), Vector2.unit("100vh"));
    }, [aspectRatio]);  // Runs only when aspectRatio changes
    
    const CanvasClass = useMemo(() => {
        return Vector2.unit("100vw") < 1200 ? "ANDROID" : "PC";
    }, [aspectRatio]);  // Runs only when aspectRatio changes

    return (
        <div id="holder" style={{width: "100vw"}}>
            <BackgroundCanvas
                ref={backgroundCanvasRef}
                resolution={resolution}
                backgroundColor={[0.05098, 0.04705, 0.05098]}
                className={CanvasClass}
            />
            {/* <Controls backgroundCanvasRef={backgroundCanvasRef} /> */}
            {
                Vector2.unit("100vw") < 1200 ? (
                    <div style={{display: "inline-block", height: "100%"}}>
                        <Page1Mobile backgroundCanvasRef={backgroundCanvasRef} aspectRatio={aspectRatio} canvasResolution={canvasResolution} />
                        <Page2Mobile />
                    </div>
                ) : (
                    <div style={{display: "inline-block", height: "100%"}}>
                        <div className="canvas-hint" ref={canvasHint}>
                            <p>
                            Left Mouse Click - <strong><i>Black Hole</i></strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; CTRL + Left Mouse Click - <strong><i>ANTI Black Hole</i></strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Left Mouse Hold and Move - <strong><i>Bomb</i></strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Right Mouse Click - <strong><i>Eraser</i></strong>
                            </p>
                        </div>
                        <Page1 backgroundCanvasRef={backgroundCanvasRef} aspectRatio={aspectRatio} canvasResolution={canvasResolution} />
                        <Page2 />
                    </div>
                )
            }
            {/* <div className='interpage' id='interpage'></div>
            <Page2 aspectRatio={aspectRatio} /> */}

            {/* {showOverlay && <PageOverlay onClose={() => setShowOverlay(false)} />} */}
        </div>
    );
}

export default App;
